import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "资料名称",
            span: 8,
            placeholder: '请输入资料名称',
            model: "name"
        },
    ]
    const tableColumns = [
        {
            label: "资料名称",
            prop: "name",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "上传时间",
            prop: "createTime",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "资料名称",
            span: 24,
            model: "name",
            placeholder: '请输入资料名称',
            labelClass: 'info-label',
        },
        {
            label: "上传资料",
            span: 24,
            model: "url",
            type: 'upload',
            action: '/account/sys/static/upload',
            labelClass: 'info-label',
            placeholder: '请上传资料',
        },
    ]

    const formRules = {
        name: [{
            required: true,
            trigger: "blur",
            message: '请输入资料名称'
        }],
        url: [{
            required: true,
            trigger: "change",
            message: '请上传资料'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
